import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DesktopChartToolbar from "./DesktopChartToolbar";
import ChartLeftToolbar from "./ChartLeftToolbar";
import ChartRightWatchlist from "./ChartRightWatchlist";
import ChartBottomBar from "./ChartBottomBar";
import SimpleModal from "./SimpleModal";
import ChartType from "../../setting/ChartType";
import Overlays from "../../setting/Overlays";
import Indicators from "../../setting/Indicators";

const DesktopChartLayout = ({
  chartSlot,
  setting,
  setSetting,
  periods,
  selectedStock,
  stockData,
  rows,
  setRows,
  initialState,
  isOverlaySubmit,
  setIsOverlaySubmit,
  isIndicatorSubmit,
  setIsIndicatorSubmit,
  overlayloader,
  indicatorloader,
  onOpenAnnotations,
  onAlert,
  onAddToWatchlist,
  onDirectShareChart,
  onStockSelect,
  onPeriodChange,
  onBuySell,
  headerHidden = false,
  editOrder,
  onEditOrderDone,
}) => {
  const [showChartType, setShowChartType] = useState(false);
  const [showOverlays, setShowOverlays] = useState(false);
  const [showIndicators, setShowIndicators] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const delays = [100, 300, 600, 1000];
    const timers = delays.map((d) =>
      setTimeout(() => window.dispatchEvent(new Event("resize")), d)
    );
    return () => timers.forEach(clearTimeout);
  }, [location.pathname]);

  return (
    <div
      className="flex flex-col overflow-hidden bg-white"
      style={{
        // Header reserve. Tuned so the header→toolbar gap matches the toolbar→
        // chart gap below it (the toolbar carries mb-3 and no vertical padding).
        // This single value is the knob: raise it if the toolbar crowds the QUSHi
        // header, lower it if the gap above the toolbar looks larger than below.
        height: headerHidden ? "100vh" : "calc(100vh - 66px)",
        marginTop: headerHidden ? 0 : "66px",
      }}
    >
      {/* The toolbar lives INSIDE the chart column, not above the whole row, so
          the right column can start at the very top of this band — its header
          (watchlist label + plus) then sits on the same baseline as the toolbar
          and the Share icon, which is the last item on the chart side of the
          chart/right-column divider. */}
      <div className="flex flex-1 min-h-0">
        <div className="flex flex-1 min-w-0 flex-col">
          <DesktopChartToolbar
            selectedStock={selectedStock}
            setting={setting}
            periods={periods}
            onOpenChartType={() => setShowChartType(true)}
            onOpenOverlays={() => setShowOverlays(true)}
            onOpenIndicators={() => setShowIndicators(true)}
            onAlert={onAlert}
            onBuySell={onBuySell}
            onShare={onDirectShareChart}
            onStockSelect={onStockSelect}
            onPeriodChange={onPeriodChange}
            leftInset={headerHidden}
          />

          <div className="flex flex-1 min-h-0">
            <ChartLeftToolbar
              onPencil={onOpenAnnotations}
              drawActive={!!setting?.drawMode}
            />

            <div className="relative flex-1 min-w-0 flex flex-col">
              <div className="relative flex-1 min-h-0 overflow-hidden">
                {chartSlot}
              </div>
              <ChartBottomBar
                periods={periods}
                setting={setting}
                setSetting={setSetting}
                onPeriodChange={onPeriodChange}
              />
            </div>
          </div>
        </div>

        <ChartRightWatchlist
          selectedStock={selectedStock}
          stockData={stockData}
          onStockSelect={onStockSelect}
          onAddToWatchlist={onAddToWatchlist}
          editOrder={editOrder}
          onEditOrderDone={onEditOrderDone}
        />
      </div>

      <SimpleModal
        open={showChartType}
        onClose={() => setShowChartType(false)}
        title="Chart Type"
      >
        <ChartType setting={setting} setSetting={setSetting} />
      </SimpleModal>

      <SimpleModal
        open={showOverlays}
        onClose={() => setShowOverlays(false)}
        title="Overlays"
        width="max-w-lg"
      >
        <Overlays
          setting={setting}
          setSetting={setSetting}
          isSubmit={isOverlaySubmit}
          setIsSubmit={setIsOverlaySubmit}
          loader={overlayloader}
        />
      </SimpleModal>

      <SimpleModal
        open={showIndicators}
        onClose={() => setShowIndicators(false)}
        title="Indicators"
        subtitle="Add up to 2 indicators."
        width="max-w-lg"
      >
        <Indicators
          setting={setting}
          setSetting={setSetting}
          isSubmit={isIndicatorSubmit}
          setIsSubmit={setIsIndicatorSubmit}
          loader={indicatorloader}
          setRows={setRows}
          rows={rows}
          initialState={initialState}
        />
      </SimpleModal>
    </div>
  );
};

export default DesktopChartLayout;
